<template>
  <page-list
    :list="list"
    :columns="columns"
    :group-actions="groupActions"
    :single-actions="singleActions"
    ref="pagelist"
    :export-data-options="exportDataOptions" />
</template>

<script>
import WindowsMixin from '@/mixins/windows'
import ListMixin from '@/mixins/list'
import ColumnsMixin from '../mixins/columns'
import SingleActionsMixin from '../mixins/singleActions'

export default {
  name: 'BillRateSetList',
  mixins: [WindowsMixin, ListMixin, ColumnsMixin, SingleActionsMixin],
  props: {
    id: String,
  },
  data () {
    return {
      list: this.$list.createList(this, {
        id: this.id,
        resource: 'ratesets',
        apiVersion: 'v1',
        getParams: {
          details: true,
        },
        hiddenColumns: ['id'],
      }),
      groupActions: [
        {
          label: this.$t('bill.create_rateset'),
          permission: 'bill_ratesets_create',
          action: () => {
            this.createDialog('BillRateSetCreateDialog', {
              data: [this.data],
              columns: this.columns,
              onManager: this.onManager,
            })
          },
          meta: () => {
            return {
              buttonType: 'primary',
            }
          },
        },
      ],
    }
  },
  computed: {
    exportDataOptions () {
      return {
        title: this.$t('bill.rateset'),
        downloadType: 'local',
        items: this.columns,
      }
    },
  },
  created () {
    this.fetchData()
  },
  methods: {
    fetchData () {
      this.list.fetchData()
    },
    handleOpenSidepage (row) {
      this.sidePageTriggerHandle(this, 'BillRateSetSidePage', {
        id: row.id,
        resource: () => {
          return {
            data: row,
          }
        },
      }, {
        list: this.list,
      })
    },
  },
}
</script>
